import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=8e62db86&scoped=true&"
import script from "./Tips.vue?vue&type=script&lang=js&"
export * from "./Tips.vue?vue&type=script&lang=js&"
import style0 from "./Tips.vue?vue&type=style&index=0&id=8e62db86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e62db86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e62db86')) {
      api.createRecord('8e62db86', component.options)
    } else {
      api.reload('8e62db86', component.options)
    }
    module.hot.accept("./Tips.vue?vue&type=template&id=8e62db86&scoped=true&", function () {
      api.rerender('8e62db86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_marginnote_landing/components/AppSale/Tips.vue"
export default component.exports